import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AssessAssistantComponent } from '../components/assess-assistant/assess-assistant.component';

@Component({
  selector: 'app-plans',
  standalone: true,
  imports: [
    AssessAssistantComponent,
    RouterOutlet
  ],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.css'
})
export class PlansComponent {
}
